import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { S3_URL} from "../services/Constants";
import {
  fetchCodeSetTable,
  updateCodeSetTable,
} from "../services/referenceTable-service";
import { useContext } from "react";
import UserContext from "../context/user-context";
import { componentIsVisible, validateAndSanitizeUrl } from "../util/common";
import { CSNANVB, CSNDB } from "../util/component-codes";

const initialRows = [
  {
    reference_table_id: null,
    reference_code: "",
    reference_Code_description: "",
    reference_Code_system: "",
  },
];
const SnomedNormalization = () => {
  const [valueSet, setValueSet] = useState("");
  const [rows, setRows] = useState(JSON.parse(JSON.stringify(initialRows)));
  const [tableId, setTableId] = useState(0);
  const [user] = useContext(UserContext);

  const addUpdateValueSet = () => {
    let copy = [...rows];
    let newArray = { ...initialRows[0] };
    copy.push(newArray);
    setRows(copy);
  };

  const updateReferenceTableValuesRows = (copyRows) => {
    let form = {
      referenceTableId: tableId,
      referenceTableName: valueSet,
      refTableValues: copyRows,
    };
    updateCodeSetTable(tableId, form);
  };

  const removeRow = (index) => {
    let copyRows = [...rows];
    copyRows.splice(index, 1);
    setRows(copyRows);
    updateReferenceTableValuesRows(copyRows);
  };

  const UpdateDescription = (index, value) => {
    let copyRows = [...rows];
    let X = copyRows[index];
    X["reference_Code_description"] = value.toUpperCase();
    setRows(copyRows);  
    if(X["reference_code"]!=="")  updateReferenceTableValuesRows(copyRows);
  };

  const UpdateCode = (index, value) => {
    let copyRows = [...rows];
    let X = copyRows[index];
    X["reference_code"] = value.toUpperCase();
    setRows(copyRows);
    if(X["reference_Code_description"]!=="") updateReferenceTableValuesRows(copyRows);
  };

  const handleValueSetChange = async (value) => {
    setValueSet(value);

    let response = await fetchCodeSetTable(value);
    if (response.ok) {
      let data = await response.json();
      setRows(data.refTableValues ? data.refTableValues : null);
      setTableId(data.referenceTableId ? data.referenceTableId : 0);
    }
  };

  useEffect(() => {
    handleValueSetChange("Normalize Snomed");
  }, []);

  return (
    <Container fluid className="loincContainer">
      <Row>
        <Col xl={8}>
          <Row className="tableTitle generalFont">SNOMED Normalization</Row>
        </Col>
      </Row>
      <br />
      <br />
      <Row>
        <Col>
          <Form.Group className="mb-3" controlId="sendingFacilityName">
            <Form.Label className="modalLabel generalFont">
              SNOMED Code Description
            </Form.Label>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="sendingFacilityCode">
            <Form.Label className="modalLabel generalFont">
              SNOMED code 
            </Form.Label>
          </Form.Group>
        </Col>
        <Col xs={1}></Col>
        <Col></Col>
        <Col></Col>
        <Col></Col>
      </Row>
      {rows &&
        rows.map((row, index) => {
          return (
            <>
              <Row>
                <Col>
                <Form.Control
                          className="modalInput generalFont"
                          type="text"
                          required
                          value={row.reference_Code_description}
                          onChange={(e) =>
                            UpdateDescription(
                              index,
                             
                              e.target.value
                            )
                          }
                        />
                </Col>

                <Col>
                  {" "}
                  <Form.Control
                          className="modalInput generalFont"
                          type="text"
                          required
                          value={row.reference_code}
                          onChange={(e) =>
                            UpdateCode(index, e.target.value)
                          }
                        />
                </Col>
                <Col xs={1}>
                  {componentIsVisible(CSNDB, user) && (
                    <Button
                      onClick={(event) => removeRow(index)}
                      className="removeButtonStylegreybackground generalFont flexCenter "
                    >
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}delete-icon.png`}
                        className="buttonIcon"
                        alt=""
                      ></img>
                    </Button>
                  )}
                </Col>
                <Col></Col>
                <Col></Col>
                <Col></Col>
              </Row>
              <br />
            </>
          );
        })}
      {componentIsVisible(CSNANVB, user) && (
        <Button
          className="modalAddUpdateStyle generalFont flexCenter"
          onClick={() => addUpdateValueSet()}
        >
          Add New Value
        </Button>
      )}
    </Container>
  );
};

export default SnomedNormalization;
